module.exports = __webpack_public_path__ + "static/media/seed10.50b08c8c.svg";